<template>
    <portal to="loading">

        <transition @before-enter="beforeOpen" @before-leave="beforeClose" leave-active-class="duration-200">
            <div v-show="show" class="flex justify-center items-center fixed inset-0 overflow-y-auto px-4 py-6 sm:px-0 -mt-36">
                <transition enter-active-class="ease-out duration-300"
                            enter-class="opacity-0"
                            enter-to-class="opacity-100"
                            leave-active-class="ease-in duration-200"
                            leave-class="opacity-100"
                            leave-to-class="opacity-0">
                    <div v-show="show" class="fixed inset-0 transform transition-all">
                        <div class="absolute z-50 inset-0 bg-gray-500 opacity-50"></div>
                    </div>
                </transition>

                <transition enter-active-class="ease-out duration-300"
                            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-active-class="ease-in duration-200"
                            leave-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div v-show="show" :class="[radius]" class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-20 w-20 transition-all sm:mx-auto"></div>
                </transition>
            </div>
        </transition>

    </portal>
</template>

<script>
export default {
    props: {
        show: false,
        fullPage: true,
        size: {
            default: 20
        }
    },

    computed: {
        radius(){
            return 'w-'+this.size+' h-'+this.size;
        }
    },

    methods: {
        beforeOpen(){
            // document.body.style.overflow = 'hidden';
            // document.body.style.paddingRight = '15px';
        },

        beforeClose(){
            // document.body.style.overflow = null;
            // document.body.style.paddingRight = null;
        }
    },

    // watch: {
    //     show: {
    //         immediate: true,
    //         handler: (show) => {
    //             if (show) {
    //                 document.body.style.overflow = 'hidden'
    //             } else {
    //                 document.body.style.overflow = null
    //             }
    //         }
    //     }
    // },

}
</script>
